export class TableDefinition {
    id: number;
    code: string;
    name: string;
    description: string;
    state: any;
}